import "./style.css";
import { registerRoute, startRouter } from "./router.js";
import { renderHome } from "./views/home.js";
import { renderSearch } from "./views/search.js";
import { renderPropositions } from "./views/propositions.js";
import { renderMembers } from "./views/members.js";
import { renderProposition } from "./views/proposition.js";
import { renderMember } from "./views/member.js";
import { renderRollCall } from "./views/rollcall.js";
import { renderMethodology } from "./views/methodology.js";

registerRoute(/^\/$/, renderHome);
registerRoute(/^\/busca\/?$/, renderSearch);
registerRoute(/^\/proposicoes\/?$/, renderPropositions);
registerRoute(/^\/parlamentares\/?$/, renderMembers);
registerRoute(/^\/proposicao\/(\d+)\/?$/, renderProposition);
registerRoute(/^\/parlamentar\/(\d+)\/?$/, renderMember);
registerRoute(/^\/votacao\/(\d+)\/?$/, renderRollCall);
registerRoute(/^\/metodologia\/?$/, renderMethodology);

startRouter();
